interface Props {
    label: string
    name: string
    type: string
    value: string | number | boolean
    onChange: (data: HTMLInputElement) => void
    disabled: boolean
    required: boolean
    hide?: boolean
}

const FormInput = (props: Props) => {

    const {label, name, type, value, onChange, disabled, required, hide} = props
    const className = type === 'checkbox' ? 'c-form-input-group--accept' : 'c-form-input-group'

    if (hide) {
        return null
    }

    return (
        <div className={className}>

            {type !== 'checkbox' && <label htmlFor={name}>{label}{required && <>*</>}</label>}

            <input type={type} id={name} name={name}
                   value={value}
                   onChange={(event: any) => {
                       onChange(event.target)
                   }}
                   disabled={disabled}
                   required={required}/>

            {type === 'checkbox' &&
                <label htmlFor={name}>Ik ga ermee akkoord om berichten van Hoorne Vastgoed te ontvangen.</label>
            }
        </div>
    )
}

export default FormInput;